import { apiClient } from "@/lib/apiClient";

export const TICKET_CATEGORIES = [
  ["account_login", "Account & Login"],
  ["billing_subscription", "Billing & Subscription"],
  ["crm_leads", "CRM & Leads"],
  ["transactions_commissions", "Transactions & Commissions"],
  ["tasks_calendar_documents", "Tasks / Calendar / Documents"],
  ["marketing", "Marketing"],
  ["resa_ai", "RESA / AI"],
  ["notifications", "Notifications"],
  ["license_compliance", "License / Compliance"],
  ["technical_issue", "Technical Issue"],
  ["other", "Other"],
];

export const FEEDBACK_MODULES = [
  ["dashboard", "Dashboard"], ["crm", "CRM"], ["pipeline", "Pipeline"], ["followup", "Follow-Up"],
  ["transactions", "Transactions"], ["commissions", "Commissions"], ["tasks", "Tasks"],
  ["calendar", "Calendar"], ["documents", "Documents"], ["marketing", "Marketing"],
  ["license_compliance", "License & Compliance"], ["goals_analytics", "Goals & Analytics"],
  ["resa", "RESA"], ["notifications", "Notifications"], ["billing", "Billing"], ["other", "Other"],
];

export const TICKET_STATUS_META = {
  open: { label: "Open", cls: "bg-blue-50 text-blue-700 border-blue-200" },
  in_progress: { label: "In Progress", cls: "bg-amber-50 text-amber-700 border-amber-200" },
  waiting_on_customer: { label: "Waiting on You", cls: "bg-purple-50 text-purple-700 border-purple-200" },
  resolved: { label: "Resolved", cls: "bg-emerald-50 text-emerald-700 border-emerald-200" },
  closed: { label: "Closed", cls: "bg-gray-100 text-gray-600 border-gray-200" },
};

export const supportService = {
  async listTickets(params = {}) { return (await apiClient.get("/support/tickets", { params })).data; },
  async getTicket(id) { return (await apiClient.get(`/support/tickets/${id}`)).data; },
  async createTicket(payload) { return (await apiClient.post("/support/tickets", payload)).data; },
  async replyTicket(id, body) { return (await apiClient.post(`/support/tickets/${id}/reply`, { body })).data; },
  async listFeatureRequests() { return (await apiClient.get("/feedback/feature-requests")).data; },
  async createFeatureRequest(payload) { return (await apiClient.post("/feedback/feature-requests", payload)).data; },
  async sendFeedback(payload) { return (await apiClient.post("/feedback", payload)).data; },
};
